import { createSlice } from '@reduxjs/toolkit';

const loadUserState = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return { response: null, token: null };
    const parsed = JSON.parse(raw);
    return {
      response: parsed?.user ? { user: parsed.user, access_token: parsed.access_token, message: parsed.message } : parsed,
      token: parsed?.access_token || null,
    };
  } catch {
    return { response: null, token: null };
  }
};

const { response: savedResponse, token: savedToken } = loadUserState();

const initialState = {
  user: null,
  response: savedResponse,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  token: savedToken,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signup: (state) => {
      state.callTimes++;
    },
    signin: (state) => {
      state.callTimes++;
    },
    failed: (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.message = typeof payload === 'string' ? payload : payload?.message || 'Something went wrong';
    },

    success: (state, { payload }) => {
      const safe = payload?.user ? { user: payload.user, access_token: payload.access_token, message: payload.message } : payload;
      localStorage.setItem('user', JSON.stringify(safe));
      localStorage.setItem('token', payload?.access_token || '');
      state.loading = false;
      state.response = safe;
      state.message = payload?.message || '';
      state.token = payload?.access_token || null;
      state.error = null;
    },
    logout: (state) => {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      state.response = null;
      state.loading = false;
      state.message = 'Logout Successfully';
      state.token = null;
    },
  },
})

// Action creators are generated for each case reducer function
export const { signup, signin, success, failed, logout } = userSlice.actions

export default userSlice.reducer